import { render } from "./SellerDetail.vue?vue&type=template&id=4560e594&scoped=true"
import script from "./SellerDetail.vue?vue&type=script&lang=js"
export * from "./SellerDetail.vue?vue&type=script&lang=js"

import "@/assets/css/layout_provider.css?vue&type=style&index=0&id=4560e594&scoped=true&lang=css"

import exportComponent from "C:\\DEVER\\meta-buysell.vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4560e594"]])

export default __exports__